export const arrayToCubicBezier = (arr: Array<number>): string => {
  const values = arr.join(', ');
  return `cubic-bezier(${values})`;
};
